/* eslint-disable prefer-destructuring */
import { connect } from 'react-redux';
import * as AuthorizeModule from './Authorize';

const mapStateToProps = ({ auth }) => ({
    user: auth.user
});

export const Authorize = connect(mapStateToProps)(AuthorizeModule.Authorize);
export const AuthorizePage = connect(mapStateToProps)(AuthorizeModule.AuthorizePage);
